import Doorphone from '@/services/api/doorphone';

export default {
  namespaced: true,
  state: {
    jobs: [],
    activeJobs: [],
    loading: false,
    pollTimer: null,
  },
  getters: {
    jobs: state => state.jobs,
    activeJobs: state => state.activeJobs,
    hasActiveJob: state => state.activeJobs.length > 0,
    queuedJobsCount: state => state.activeJobs.filter(j => j.status === 'queued').length,
    runningJobsCount: state => state.activeJobs.filter(j => j.status === 'running').length,
    queuedJobs: state => state.activeJobs.filter(j => j.status === 'queued'),
    loading: state => state.loading,
  },
  mutations: {
    setJobs (state, jobs) {
      state.jobs = jobs || [];
    },
    setActiveJobs (state, jobs) {
      state.activeJobs = jobs || [];
    },
    setLoading (state, loading) {
      state.loading = loading;
    },
    setPollTimer (state, timer) {
      state.pollTimer = timer;
    },
  },
  actions: {
    fetchJobs ({ commit }, { active = false } = {}) {
      commit('setLoading', true);
      return Doorphone.getMassAudioUploadJobs({ active })
        .then(({ data }) => {
          const jobs = data.jobs || [];
          if (active) {
            commit('setActiveJobs', jobs);
          } else {
            commit('setJobs', jobs);
            commit('setActiveJobs', jobs.filter(j => ['queued', 'running'].includes(j.status)));
          }
          return jobs;
        })
        .finally(() => {
          commit('setLoading', false);
        });
    },

    fetchActive ({ dispatch }) {
      return dispatch('fetchJobs', { active: true });
    },

    cancelJob ({ dispatch }, massUploadId) {
      return Doorphone.cancelMassAudioUploadJob(massUploadId)
        .then((response) => {
          return dispatch('fetchActive').then(() => response);
        });
    },

    startPolling ({ state, commit, dispatch }) {
      if (state.pollTimer) {
        return;
      }
      const tick = () => {
        dispatch('fetchActive').then((jobs) => {
          if (!jobs || jobs.length === 0) {
            dispatch('stopPolling');
          }
        }).catch(() => {});
      };
      tick();
      const timer = setInterval(tick, 7000);
      commit('setPollTimer', timer);
    },

    stopPolling ({ state, commit }) {
      if (state.pollTimer) {
        clearInterval(state.pollTimer);
        commit('setPollTimer', null);
      }
    },

    exportResult (_, massUploadId) {
      return Doorphone.exportAudioUpload(massUploadId)
        .then((response) => {
          const disposition = response.headers['content-disposition'] || '';
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          let filename = `mass-audio-upload-${massUploadId}.csv`;
          if (match && match[1]) {
            filename = decodeURIComponent(match[1].replace(/['"]/g, '').replace(/UTF-8''/i, ''));
          }
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        });
    },

    downloadAudioFile (_, massUploadId) {
      return Doorphone.downloadAudioUploadFile(massUploadId)
        .then((response) => {
          const disposition = response.headers['content-disposition'] || '';
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          const contentType = response.headers['content-type'] || '';
          const isZip = contentType.includes('zip') || (match && match[1] && String(match[1]).toLowerCase().includes('.zip'));
          const isBmp = contentType.includes('bmp') || (match && match[1] && String(match[1]).toLowerCase().includes('.bmp'));
          let filename = isZip
            ? `mass-media-upload-${massUploadId}.zip`
            : (isBmp ? `mass-lcd-upload-${massUploadId}.bmp` : `mass-audio-upload-${massUploadId}.wav`);
          if (match && match[1]) {
            filename = decodeURIComponent(match[1].replace(/['"]/g, '').replace(/UTF-8''/i, ''));
          }
          const blob = new Blob([response.data], {
            type: isZip ? 'application/zip' : (isBmp ? 'image/bmp' : 'audio/wav'),
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        });
    },
  },
};
